<template>    
  <div>
    <div class="row" v-if="compMode != CRUDMODE.READ">
      <table id="dataTablePersonCompany" width="100%" cellspacing="0" 
          class="table table-bordered table-striped dataTable"  >
        <thead>
          <tr>
            <th width="200">{{ $t('project.company.form.conseil.type') }}</th>
            <th>{{ $t('project.company.form.conseil.person') }}</th>
            <th width="250">{{ $t('project.company.form.conseil.role') }}</th>
            <th width="150">{{ $t('project.company.form.conseil.notPaid') }}</th>
            <th width="150">{{ $t('project.company.form.conseil.actionsOptions') }}</th>
            <th width="150">{{ $t('project.company.form.conseil.actions') }}</th>
            <th width="150">{{ $t('project.company.form.conseil.flatRate') }}</th>
            <th width="150">{{ $t('project.company.form.conseil.attendanceToken') }}</th>
            <th width="50" v-if="compMode != CRUDMODE.READ"></th>
          </tr>
        </thead>
        <tfoot>
          <tr>
            <th width="200">{{ $t('project.company.form.conseil.type') }}</th>
            <th>{{ $t('project.company.form.conseil.person') }}</th>
            <th>{{ $t('project.company.form.conseil.role') }}</th>
            <th>{{ $t('project.company.form.conseil.notPaid') }}</th>
            <th>{{ $t('project.company.form.conseil.actionsOptions') }}</th>
            <th>{{ $t('project.company.form.conseil.actions') }}</th>
            <th>{{ $t('project.company.form.conseil.flatRate') }}</th>
            <th>{{ $t('project.company.form.conseil.attendanceToken') }}</th>
            <th v-if="compMode != CRUDMODE.READ"></th>
          </tr>
        </tfoot>
        <tbody>
          <tr class="odd" v-if="mutableCompanyPersons.length == 0">
              <td valign="top" colspan="9" class="dataTables_empty">{{ $t("form.aucun_donne") }}</td>
          </tr>
          <tr v-for="(item, index) in mutableCompanyPersons" v-bind:data-id="item.id" :key="item.id">
            <td>
                <select class="form-control" v-model="item.type">
                    <option value=1>{{ $t('project.company.form.conseil.member') }}</option>
                    <option value=2>{{ $t('project.company.form.conseil.user') }}</option>
                    <option value=3>{{ $t('project.company.form.conseil.entrepreneur') }}</option>
                    <option value=4>{{ $t('project.company.form.conseil.another') }}</option>                 
                </select>
            </td>
            <td v-if="item.type == 1">
              
              <multiselect v-model="item.member" id="ajax" :custom-label="memberLabel" 
                track-by="id" :placeholder="$t('project.company.form.conseil.member')" open-direction="bottom" 
                :options="members" :multiple="false" :searchable="true" :loading="isLoading" 
                :internal-search="false" :clear-on-select="true" :close-on-select="true" 
                :options-limit="300" :max-height="600" :show-no-results="true" 
                :hide-selected="true" @search-change="asyncMemberFind"
                :select-label="$t('multiselect.select-label')">

                <span slot="noResult">{{ $t('multiselect.not-found') }} </span>
              </multiselect>

            </td>

            <td v-if="item.type == 2">
                
                <multiselect v-model="item.associatedUser" id="ajax" :custom-label="userLabel" 
                  track-by="id" :placeholder="$t('project.company.form.conseil.user')" open-direction="bottom" 
                  :options="users" :multiple="false" :searchable="true" :loading="isLoading" 
                  :internal-search="false" :clear-on-select="true" :close-on-select="true" 
                  :options-limit="300" :max-height="600" :show-no-results="true" 
                  :hide-selected="true" @search-change="asyncUserFind"
                  :select-label="$t('multiselect.select-label')">

                <span slot="noResult">{{ $t('multiselect.not-found') }} </span>
              </multiselect>
            </td>

            <td v-if="item.type == 3">
                <multiselect v-model="item.entrepreneur" id="ajax" :custom-label="entrepreneurLabel" 
                    track-by="id" :placeholder="$t('project.company.form.entrepreneur.name')" open-direction="bottom" 
                    :options="entrepreneurs" :multiple="false" :searchable="true" :loading="isLoading" 
                    :internal-search="false" :clear-on-select="true" :close-on-select="true" 
                    :options-limit="300" :max-height="600" :show-no-results="true" 
                    :hide-selected="true" @search-change="asyncEntrepreneurFind"
                    :select-label="$t('project.company.form.entrepreneur.select')">

                    <span slot="noResult">{{ $t('project.company.form.entrepreneur.notFound') }} </span>
                  </multiselect>

            <td v-if="item.type == 4">
                <input maxlength="100" v-model.trim="item.name" v-validate="'required'" name="name" type="text" 
                  class="form-control" id="nameInput" placeholder="Nom"  /> 
            </td>
            <td v-if="item.type == undefined">
                &nbsp;
            </td>

            <td>
              <select v-model="item.personRole" v-validate="'required'" class="form-control" id="statusInput">
                <option v-for="s in roles" :value="s.item1" :key="s.item1">{{s.item2}}</option>
              </select>
            </td>
            <td>
              <label class="custom-control custom-checkbox">
                  <input type="checkbox" name="notPaid" value="1" class="custom-control-input" id="notPaid" v-model="item.notPaid" @click="f=>notPaidChecked(item)">
                  <span class="custom-control-indicator"></span>
                  <span class="custom-control-label">{{$t("yes")}}</span>
              </label>
            </td>
            <td>
              <input v-money="{}" name="actionsOptions" type="text" class="form-control" id="actionsOptions"  v-model="item.actionsOptions" :disabled="item.notPaid == true" /> <!-- Somehow breaks the disableds if dont have at least one verification to true -->
            </td>
            <td>
              <input v-money="{}" name="actions" type="text" class="form-control" id="actions" v-model="item.actions" :disabled="item.notPaid" />
            </td>
            <td>
              <input name="flatRate" type="text" class="form-control" id="flatRate" v-model="item.flatRate" :disabled="item.notPaid" />
            </td>
            <td>
              <input name="attendanceToken" type="text" class="form-control" id="attendanceToken" v-model="item.attendanceToken" :disabled="item.notPaid" />
            </td>
            <td align=center v-if="compMode != CRUDMODE.READ">
              <a class="text-danger" v-bind:title="$t('form.delete_button')" href="#person" v-on:click="removePerson(index)">
                  <span class="fa fa-lg fa-trash"></span>
              </a>
            </td> 
          </tr>
        </tbody>
      </table>
    </div>

    <ul class="item-view" v-if="compMode == CRUDMODE.READ">
      <li v-if="mutableCompanyPersons == null || mutableCompanyPersons.length == 0">
        {{ $t("form.aucun_donne") }}
      </li>
      <li v-for="item in mutableCompanyPersons" v-bind:data-id="item.id" :key="item.id">

        <div class="row">
          <div class="form-group col-md-2">
            <label>{{ $t('project.company.form.conseil.type') }}</label>
            <select class="form-control" v-model="item.type" disabled>
              <option value=1>{{ $t('project.company.form.conseil.member') }}</option>
              <option value=2>{{ $t('project.company.form.conseil.user') }}</option>
              <option value=3>{{ $t('project.company.form.conseil.entrepreneur') }}</option>
              <option value=4>{{ $t('project.company.form.conseil.another') }}</option>                 
            </select>
          </div>
          <div class="form-group col-md-4">
            <label>{{ $t('project.company.form.conseil.person') }}</label>
            <div class="input-group mb-3">
              <input v-if="item.type == 1" :value="item.member.familyName + ', ' + item.member.name" type=text class="form-control" disabled />
              <input v-if="item.type == 2" :value="item.associatedUser.fullName" type=text class="form-control" disabled />
              <input v-if="item.type == 3" :value="item.entrepreneur.familyName +', '+ item.entrepreneur.name" type=text class="form-control" disabled />
              <input v-if="item.type == 4" v-model="item.name" type=text class="form-control" disabled />

              <div class="input-group-append" v-if="item.type != 4">
                <button class="btn btn-outline-secondary" v-on:click.stop="showPersonPage(item)" type="button"><span class="fa fa-lg fa-link"></span></button>
              </div>
            </div>
            
          </div>
          <div class="form-group col-md-2">
            <label>{{ $t('project.company.form.conseil.role') }}</label>
            <select v-model="item.personRole" class="form-control" id="statusInput" disabled>
              <option v-for="s in roles" :value="s.item1" :key="s.item1">{{s.item2}}</option>
            </select>
          </div>
          <div class="form-group col-md-4" v-if="item.notPaid">
            <label>{{ $t('project.company.form.conseil.notPaid') }}</label>
            <label class="custom-control custom-checkbox">
              <input type="checkbox" name="notPaid" value="1" disabled class="custom-control-input" id="notPaid" v-model="item.notPaid">
              <span class="custom-control-indicator"></span>
              <span class="custom-control-label">{{ $t("yes") }}</span>
            </label>
          </div>
          <div class="form-group col-md-1" v-if="!item.notPaid">
            <label>{{ $t('project.company.form.conseil.actionsOptions') }}</label>
            <input type=text class="form-control" v-model="item.actionsOptions" disabled />
          </div>
          <div class="form-group col-md-1" v-if="!item.notPaid">
            <label>{{ $t('project.company.form.conseil.actions') }}</label>
            <input type=text class="form-control"  v-model="item.actions" disabled />
          </div>
          <div class="form-group col-md-1" v-if="!item.notPaid">
            <label>{{ $t('project.company.form.conseil.flatRate') }}</label>
            <input type=text class="form-control"  v-model="item.flatRate" disabled />
          </div>
          <div class="form-group col-md-1" v-if="!item.notPaid">
            <label>{{ $t('project.company.form.conseil.attendanceToken') }}</label>
            <input type=text class="form-control"  v-model="item.attendanceToken" disabled />
          </div>
        </div>
        <!-- Member data -->
        <div class="row" v-if="item.type == 1">
          <div class="form-group col-md-3">
            <label>{{ $t('member.form.designation') }}</label>
            <input :value="item.member.designation" name="designation" type="text" class="form-control" disabled />
          </div>
          <div class="form-group col-md-3">
            <label>{{ $t('member.form.sex') }}*</label>
            <input :value="item.member.sexText" name="sex" type="text" class="form-control" disabled />
          </div>
          <div class="form-group col-md-3">
            <label>{{ $t('member.form.nativeLanguage') }}*</label>
            <input :value="item.member.nativeLanguage" name="nativeLanguage" type="text" class="form-control" disabled />
          </div>
          <div class="form-group col-md-3">
            <label>{{ $t('member.form.birthdate') }}*</label>
            <input :value="item.member.birthdate | formatDate" name="birthdate" type="text" class="form-control" disabled />
          </div>
        </div>
        <div class="row" v-if="item.type == 1">
          <div class="form-group col-md-3">
            <label>{{ $t('member.form.email') }}</label>
            <input :value="item.member.email" name="email" type="text" class="form-control" disabled />
          </div>
          <div class="form-group col-md-3">
            <label>{{ $t('member.form.cellphone') }}*</label>
            <input :value="item.member.cellphone" name="cellphone" type="text" class="form-control" disabled />
          </div>
          <div class="form-group col-md-3">
            <label>{{ $t('member.form.phone') }}*</label>
            <input :value="item.member.phone" name="phone" type="text" class="form-control" disabled />
          </div>
          <div class="form-group col-md-3">
            <label>{{ $t('member.form.officePhone') }}*</label>
            <input :value="item.member.officePhone + (item.member.officePhoneExtension != null ? '#' + item.member.officePhoneExtension : '')" name="officePhone" type="text" class="form-control" disabled />
          </div>
        </div>
        <!-- User data -->
        <div class="row" v-if="item.type == 2">
          <div class="form-group col-md-6">
            <label>{{ $t('user.form.emailAddress') }}</label>
            <input :value="item.associatedUser.emailAddress" name="emailAddress" type="text" class="form-control" disabled />
          </div>
          <div class="form-group col-md-6">
            <label>{{ $t('user.form.phone') }}*</label>
            <input :value="item.associatedUser.phoneNumber" name="phoneNumber" type="text" class="form-control" disabled />
          </div>
        </div>
        <!-- Entrepreneur -->
        <div class="row" v-if="item.type == 3">
          <div class="form-group col-md-3">
            <label>{{ $t('entrepreneur.form.education') }}*</label>
            <input :value="item.entrepreneur.education" name="education" type="text" class="form-control" disabled />
          </div>
          <div class="form-group col-md-3">
            <label>{{ $t('entrepreneur.form.sex') }}*</label>
            <input :value="item.entrepreneur.sexText" name="sex" type="text" class="form-control" disabled />
          </div>
          <div class="form-group col-md-3">
            <label>{{ $t('entrepreneur.form.language') }}*</label>
            <input :value="item.entrepreneur.language" name="language" type="text" class="form-control" disabled />
          </div>
          <div class="form-group col-md-3">
            <label>{{ $t('entrepreneur.form.birthdate') }}*</label>
            <input :value="item.entrepreneur.birthdate | formatDate" name="birthdate" type="text" class="form-control" disabled />
          </div>
        </div>
        <div class="row" v-if="item.type == 3">
          <div class="form-group col-md-3">
            <label>{{ $t('entrepreneur.form.email') }}</label>
            <input :value="item.entrepreneur.email" name="email" type="text" class="form-control" disabled />
          </div>
          <div class="form-group col-md-3">
            <label>{{ $t('entrepreneur.form.cellphone') }}*</label>
            <input :value="item.entrepreneur.cellphone" name="cellphone" type="text" class="form-control" disabled />
          </div>
          <div class="form-group col-md-3">
            <label>{{ $t('entrepreneur.form.phone') }}*</label>
            <input :value="item.entrepreneur.phone" name="phone" type="text" class="form-control" disabled />
          </div>
          <div class="form-group col-md-3">
            <label>{{ $t('entrepreneur.form.officePhone') }}*</label>
            <input :value="item.entrepreneur.officePhone + (item.entrepreneur.officePhoneExtension != null ? '#' + item.entrepreneur.officePhoneExtension : '')" disabled name="officePhone" type="text" class="form-control" />
          </div>
        </div>
         <div class="row" v-if="item.type == 3">
          <div class="form-group col-md-3">
            <label>{{ $t('entrepreneur.form.numberEnterpriseAsManager') }}</label>
            <input :value="item.entrepreneur.numberEnterpriseAsManager" name="numberEnterpriseAsManager" type="text" disabled class="form-control" />
          </div>
          <div class="form-group col-md-9">
            <label>{{ $t('entrepreneur.form.social.title') }}*</label>
            <input :value="getSocial(item.entrepreneur.social)" name="socialNetwork" type="text" class="form-control" disabled />
          </div>
        </div>
      </li>
    </ul>
   
  </div>
        
</template>

<script>
  import {
    CompanyServiceClient,
    CompanyPersonServiceClient,
    CompanyPersonDto,
    MemberServiceClient,
    UserServiceClient,
    EntrepreneurServiceClient,
    MemberDto,
    UserDto,
    EntrepreneurDto,
  } from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'
  import Multiselect from 'vue-multiselect'

  export default {
    name: 'CompanyPerson',
    props: {
      companyPersons: {},
    },
    data() {
      return {
        members: [],
        users: [],
        roles: [],
        entrepreneurs: [],
        isLoading: false,
        mutableCompanyPersons: [],
      }
    },
    mixins: [CrudMixin],
    mounted: function() {
      let self = this
      setTimeout(function() {
        self.mutableCompanyPersons = self.companyPersons
        self.fetchData()
        self.setMode()
      }, 1000)
    },
    methods: {
      getSocial: function(social) {
        if (social == null || social.socialNetworks == null) return ''
        return social.socialNetworks.join(',')
      },
      showPersonPage: function(item) {
        let routeData = null
        if (item.type == 1)
          // Member
          routeData = this.$router.resolve({path: '/members/view/' + item.memberId})
        else if (item.type == 2)
          // User
          routeData = this.$router.resolve({path: '/users/edit/' + item.associatedUserId})
        else if (item.type == 3)
          // Entrepreneur
          routeData = this.$router.resolve({path: '/entrepreneurs/view/' + item.entrepreneurId})

        if (routeData != null) window.open(routeData.href, '_blank')
      },
      fetchData: function() {
        let companyService = ServiceFactory.create(CompanyServiceClient)
        let getPersonRole = companyService.getPersonRole()
        let self = this

        getPersonRole
          .then(res => {
            self.roles = res
          })
          .catch(err => {
            console.log(err)
          })

        //6 = AngesRepresentative, we don't want that here.
        this.mutableCompanyPersons = this.mutableCompanyPersons.filter(c => c.personRole != 6)
      },
      addPerson: function() {
        let dto = new CompanyPersonDto()
        dto.init({notPaid: false})
        this.mutableCompanyPersons.push(dto)
        this.companyPersons.push(dto)
      },
      removePerson: function(index) {
        this.companyPersons.splice(index, 1)
        this.mutableCompanyPersons.splice(index, 1)
      },
  
      asyncMemberFind: function(query) {
        this.isLoading = true
  
        let service = ServiceFactory.create(MemberServiceClient)
        let self = this

        service.getAutocomplete(query).then(response => {
          self.members = _.map(response, item => {
            let dto = new MemberDto()
            dto.init(item)
            return dto
          })
          self.isLoading = false
        })
      },
      memberLabel: function(obj) {
        return obj.familyName + ', ' + obj.name
      },

      asyncUserFind: function(query) {
        if (query.length > 0) {
          this.isLoading = true
          let service = ServiceFactory.create(UserServiceClient)

          let self = this
          service.getAutocomplete(query).then(response => {
            self.users = _.map(response, user => {
              let userDto = new UserDto()
              userDto.init(user)
              return userDto
            })

            self.isLoading = false
          })
        }
      },
      userLabel: function(option) {
        return option.id + ' - ' + option.firstName + ' ' + option.lastName
      },
      entrepreneurLabel: function(obj) {
        return obj.familyName + ', ' + obj.name
      },
      asyncEntrepreneurFind: function(query) {
        this.isLoading = true
  
        let service = ServiceFactory.create(EntrepreneurServiceClient)
        let self = this

        service.getAutocomplete(query).then(response => {
          self.entrepreneurs = response
          self.isLoading = false
        })
      },
      notPaidChecked: function(item) {
        if (!item.notPaid) {
          item.actionsOptions = null
          item.actions = null
          item.flatRate = null
          item.attendanceToken = null
        }
      },
    },
    components: {
      multiselect: Multiselect,
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>



// WEBPACK FOOTER //
// src/components/projects/CompanyPerson.vue